import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode, HTMLAttributes } from 'react';
import styled, { Interpolation } from 'styled-components';

interface ModalContentProps extends HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
    className?: string;
    styles?: Interpolation<CSSProperties>;
}

const StyledModalContent = styled.div<{ styles?: Interpolation<CSSProperties> }>`
    padding: 8px 24px;
    overflow-y: auto;
    ${({ styles }) => styles};
`;

const ModalContent: FC<ModalContentProps> = ({ children, styles, className, ...rest }) => {
    return (
        <StyledModalContent
            className={classNames('modal-content', className)}
            styles={styles}
            {...rest}
        >
            {children}
        </StyledModalContent>
    );
};

export default ModalContent;
